module.exports = __webpack_public_path__ + "static/media/trash-black.feef2809.svg";